var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCodeigniter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE4323;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,48.9c-3-1.2-5.7-4.5-5.7-7.8c0-3.6,2.2-6.7,5.1-8.7c-0.4,1.2-0.5,2.5,0.4,3.6c0.7,1.1,2.1,1.6,3.5,1.4 c3-0.6,3.2-4,1.4-6c-1.7-1.9-3.5-4.1-2.9-6.8c0.4-1.4,1.2-2.7,2.2-3.6c-0.9,2.2,1.5,4.3,3.1,5.5c2.7,1.9,5.7,3.2,8.2,5.5 c2.6,2.4,4.6,5.5,4.2,9.1c-0.4,4-3.5,6.6-7.1,8.1c7.3-1.6,15-7.3,15.1-15.5c0.1-6.7-4.5-11.9-10.2-14.9l-0.2-0.1 c0.1,0.4,0.2,0.7,0.2,1c0-0.2,0.1-0.4,0.1-0.6c0,0.2,0,0.5-0.1,0.7v-0.1c-0.1,0.4-0.2,0.7-0.4,1l0.1-0.1c-1.1,1.9-4.2,2.4-5.7,0.4 c-2.5-3.1,0-6.6,0.4-9.9c0.2-4.3-2.4-8.3-5.7-10.8c1.7,2.9-0.6,6.7-2.5,8.9C20.2,11,18,12.8,16,14.6c-2.1,2-4.2,4.2-6.1,6.6 C6.3,25.9,4.2,32,5.8,38C7.4,43.8,12.6,47.5,18.5,48.9L18.5,48.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeigniter);
export default __webpack_public_path__ + "static/media/codeigniter.38ab60897e7a63925f06302ecab2994d.svg";
export { ForwardRef as ReactComponent };